<ws-modal-wrapper
    [headerLabel]="headerLabel"
    acceptLabel="Save"
    cancelLabel="Cancel"
    acceptClass="btn-primary"
    cancelClass="btn-outline-primary"
    [disableSave]="disableSave"
    (save)="save()"
    (cancel)="cancel()"
>
    <div class="mb-3">
        <label for="approval-comment" class="form-label">Comment:</label>
        <textarea
            id="approval-comment"
            class="form-control"
            [(ngModel)]="comment"
            rows="4"
            placeholder="Enter an approval comment..."
        ></textarea>
    </div>
</ws-modal-wrapper>
